<template lang="pug">
  app-modal(
    :modalNova="true",
    :closeOutside="false",
    :titulo="`Vincular processo ${isCertidao ? 'a Certidão' : 'ao Título'}`",
    :width="700",
    @closeModal="closeModal()"
  )
    template(slot="body")
      validation-observer(ref="observer")
        validation-provider(rules="required", v-slot="{ errors }")
          .document-name-container
            span.document-name {{  nomeDocumento }}
            hr
          el-row.flex
            app-label(label="Informe o número do processo:",:required="true")
            el-tooltip(placement="top-start", :open-delay="500")
              template(slot="content")
                span(v-html="getTextoTooltip")
              font-awesome-icon.icon-info(icon="info-circle")
          el-input.input.width-50(
            v-model="campo"
            :disabled="showPesquisar"
            v-mask="['#########/####']"
            :class="{'erro' : errors.length}"
            type="text"
            @keyup.native.enter="consultar"
          )
          br
          span.help.erro {{ errors[0] }}
          span.error-message(v-show="notificacao") {{ $messages.VINCULAR_PROCESSO }}
      div.margin-top(v-show="processo.tipo.nome")
        app-label(label="Tipo do processo:")
        el-input.input.width-50(
          v-model="processo.tipo.nome"
          type="text"
          :disabled="true"
        )
      div.margin-top(v-show="processo.nomeRazaoSocialInteressado")
        app-label(label="Nome/Razão Social do Interessado:")
        el-input.input.width-50(
          v-model="processo.nomeRazaoSocialInteressado"
          type="text"
          :disabled="true"
        )
      div.margin-top(v-show="processo.cpfCnpjInteressado")
        app-label(label="CPF/CNPJ do Interessado:")
        el-input.input.width-50(
          v-model="processo.cpfCnpjInteressado"
          type="text"
          :disabled="true"
        )
      div.margin-top(v-show="processo.setor")
        app-label(label="Setor atual:")
        el-input.input.width-50(
          v-model="processo.setor"
          type="text"
          :disabled="true"
        )
      div.margin-top(v-show="processo.status")
        app-label(label="Situação atual")
        el-input.input.width-50(
          v-model="statusFormatado"
          type="text"
          :disabled="true"
        )
    template(slot="footer")
      .buttons
        el-button(
          type="default",
          key="botao-cancelar",
          @click="closeModal()"
        ) Cancelar

        el-button(
          v-if="!processo.cpfCnpjInteressado",
          type="primary",
          key="botao-pesquisa",
          @click="consultar()"
        ) Pesquisar

        el-button(
          v-show="processo.cpfCnpjInteressado ",
          type="primary",
          key="botao-confirma",
          :disabled= "!showIncluir"
          @click="incluir()"
        ) Incluir
</template>

<script>
import AppModal from '@/components/AppModal'
import AppLabel from '@/components/AppLabel'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import axios from '@/utils/api'
import statusProcessos from '@/constants/statusProcessos'

export default {

  components: {
    AppModal,
    AppLabel
  },

  mixins: [
    AppNotificacao
  ],

  props: {
    nomeDocumento: {
      type: String,
      require: true
    },
    tipoDocumento: {
      type: String,
      require: true
    }
  },

  data () {
    return {
      campo: '',
      notificacao: false,
      showIncluir: false,
      showPesquisar: false,
      idDocumento: null,
      processo: {
        tipo: {
          nome: ''
        },
        nomeRazaoSocialInteressado: '',
        cpfCnpjInteressado: null,
        setor: '',
        status: '',
        id: null
      },
      statusFormatado: '',
      tooltipInfos: ''
    }
  },

  computed: {
    isCertidao () {
      return this.tipoDocumento === 'Certidão de Autenticidade de Títulos'
    },

    getTextoTooltip () {
      switch (this.tipoDocumento) {
        case 'Certidão de Autenticidade de Títulos':
          return 'Condições para permitir vincular título a um processo:<br />Tipo do processo: Certidão de Título<br />Setor: GIT<br />Situação:<br />- Aguardando Emissão de Certidão<br />- Em Emissão de Certidão'
        case 'Título REURB':
          return 'Condições para permitir vincular título a um processo:<br />Tipo do processo: Reurb-S<br />Setor: GIT<br />Situação:<br />- Aguardando Emissão de Título<br />- Em Emissão de Título'
        default:
          return 'Condições para permitir vincular título a um processo:<br />Tipo do processo: Não Oneroso e Oneroso<br />Setor: GIT<br />Situação:<br />- Aguardando Emissão de Título<br />- Em Emissão de Título'
      }
    },

    getTiposCadastro () {
      switch (this.tipoDocumento) {
        case 'Certidão de Autenticidade de Títulos':
          return 'CERTIDAO'
        case 'Título REURB':
          return 'REURB'
        default:
          return 'ONEROSO_NAO_ONEROSO'
      }
    }
  },

  methods: {

    formatarStatus () {
      this.statusFormatado = statusProcessos.find(s => s.codigo === this.processo.status)?.nome
      if (!this.statusFormatado) {
        this.statusFormatado = this.processo.status.replace(/_/g, ' ')
      }
    },
    closeModal () {
      this.$emit('closeModal')
    },
    incluir () {
      this.$emit('incluir', this.processo.id)
    },
    async consultar () {
      const tiposPermitidos = {
        ONEROSO_NAO_ONEROSO: ['NAO_ONEROSO', 'ONEROSO'],
        CERTIDAO: ['CERTIDAO_TITULO'],
        REURB: ['REURB-S']
      }
      const statusPermitidos = ['AGUARDANDO_EMISSAO_TITULO', 'AGUARDANDO_EMISSAO_CERTIDAO', 'EM_EMISSAO_TITULO', 'EM_EMISSAO_CERTIDAO']
      const setoresPermitidos = ['GIT', 'CDI']
      this.showPesquisar = true
      axios({
        method: 'GET',
        url: `processo/findByNumero?numeroProcesso=${this.campo}`
      }).then((retorno) => {
        if (retorno) {
          this.processo = retorno
          this.formatarStatus()
          if (this.processo !== null &&
            this.processo.status !== null &&
            setoresPermitidos.includes(this.processo.setor) &&
            tiposPermitidos[this.getTiposCadastro].includes(this.processo.tipo.codigo) &&
            statusPermitidos.includes(this.processo.status)) {
            this.notificacao = false
            this.showIncluir = true
          } else {
            this.notificacao = true
          }
        } else {
          this.notificacao = true
          this.showIncluir = true
          this.showPesquisar = false
        }
      }).catch(() => {
        this.showPesquisar = false
      })
    }
  }
}

</script>

<style lang="scss" scoped>
.text-container >>> .label-divider {
  padding-top: 0px;
}

.container-input {
  padding-right: 20px;
}

.input {
  width: 100%;
}

.row {
  padding-left: 10px;
  padding-right: 10px;
}

.buttons {
  display: flex;
  justify-content: space-between;
}
.error-message {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}
.el-button.is-disabled {
    background-color: #ccc;
    border-color: #ccc;
    color: #666;
    cursor: not-allowed;
}
.icon-info {
  margin-inline: 5px;
  cursor: pointer;
}
.flex{
  display: flex;
}
.document-name {
  font-weight: bold;
  margin-bottom: 5px;
}
.document-name-container {
  margin-bottom: 5px;
}
.margin-top {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/screens/assinatura/VincularProcesso.vue